import './styles.scss';

function FormLabel({ children, type, required, addStyle }) {
  const classes = `FormLabel__text ${
    type === 'big' ? 'FormLabel__text--big' : ''
  } ${required ? 'FormLabel__text--required' : ''}`;

  return (
    <p className={classes} style={addStyle || {}}>
      {children}
    </p>
  );
}

export default FormLabel;
